<template>
  <div class="excavation-dims">
    <div class="excavation-dims__field">
      <app-field-label>Length (m)</app-field-label>
      <app-text-input
        type="number"
        step="0.1"
        placeholder="0.0"
        :model-value="calculation.length"
        @update:model-value="onLength"
      />
    </div>
    <div class="excavation-dims__field">
      <app-field-label>Width (m)</app-field-label>
      <app-text-input
        type="number"
        step="0.1"
        placeholder="0.0"
        :model-value="calculation.width"
        @update:model-value="onWidth"
      />
    </div>
    <div class="excavation-dims__field">
      <app-field-label>Depth (m)</app-field-label>
      <app-text-input
        type="number"
        step="0.1"
        placeholder="0.0"
        :model-value="calculation.depth"
        @update:model-value="onDepth"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExcavationDimensionFields',
  props: {
    calculation: {
      type: Object,
      required: true
    }
  },
  methods: {
    onLength: function (value) {
      this.$set(this.calculation, 'length', value)
    },
    onWidth: function (value) {
      this.$set(this.calculation, 'width', value)
    },
    onDepth: function (value) {
      this.$set(this.calculation, 'depth', value)
    }
  }
}
</script>

<style scoped>
.excavation-dims {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 16px;
}
.excavation-dims__field {
  flex: 1 1 0 !important;
  min-width: 0 !important;
  margin: 0 !important;
  float: none !important;
  clear: none !important;
  width: auto !important;
  max-width: none !important;
}
.excavation-dims__field :deep(.smardie-text-input),
.excavation-dims__field :deep(.smardie-text-input input) {
  width: 100%;
  box-sizing: border-box;
}
.excavation-dims__field :deep(.smardie-text-input input) {
  margin: 0;
  min-height: 44px;
  height: 44px;
}
</style>
